module.exports = __webpack_public_path__ + "gg.svg?02df8a5dc2a174160c2ff4febae8c1f6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/gg.svg
// module id = 1371
// module chunks = 0